import { Tab, Tabs } from '@mui/material';

import { EnvironmentModel } from '../../../api/api';

export default function EnvironmentTabs({
	environments,
	environmentId,
	onChange,
	disabled = false,
	label = 'Environments',
	idPrefix,
}: {
	environments: EnvironmentModel[];
	environmentId?: string;
	onChange(environmentId: string): void;
	disabled?: boolean;
	label?: string;
	idPrefix?: string;
}) {
	return (
		<Tabs
			value={environments.some((environment) => environment.id === environmentId) ? environmentId : false}
			variant="scrollable"
			scrollButtons="auto"
			aria-label={label}
			onChange={(_, id: string) => onChange(id)}
			sx={{ mb: 2 }}
		>
			{environments.map((environment) => (
				<Tab
					key={environment.id}
					value={environment.id}
					label={environment.name}
					disabled={disabled}
					id={idPrefix ? `${idPrefix}-${environment.id}` : undefined}
					aria-controls={idPrefix ? `${idPrefix}-panel` : undefined}
				/>
			))}
		</Tabs>
	);
}
